export const CONVERSATION_TYPE__CONTACT = 'contact';
export const CONVERSATION_TYPE__CHANNEL = 'channel';



// WEBPACK FOOTER //
// ./src/modules/conversations/constants/index.js